import { Button, ButtonProps } from 'omakase';
import { CircularProgress } from '@material-ui/core';
import React from 'react';

export interface SubmitButtonProps
  extends ButtonProps,
    Pick<React.ComponentPropsWithRef<'button'>, 'type'> {
  isSubmitting?: boolean;
}

const SubmitButton: React.FunctionComponent<SubmitButtonProps> = ({
  children,
  isSubmitting = false,
  disabled = false,
  type = 'submit',
  variant = 'primary',
  ...rest
}) => {
  return (
    <Button
      component="button"
      aria-label={isSubmitting ? 'Submitting' : undefined}
      disabled={isSubmitting || disabled}
      type={type}
      variant={variant}
      iconStart={isSubmitting ? <CircularProgress size="2.4rem" /> : undefined}
      {...rest}
    >
      {!isSubmitting && <span>{children}</span>}
    </Button>
  );
};

export default SubmitButton;
